import { Router, RouterLink } from '@angular/router';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass } from '@angular/common';
import { IndexIoService } from '../../services/index-io.service';

@Component({
  selector: 'bnpp-indx-predisclaimer',
  imports: [NgClass, FormsModule, InputTextModule, RouterLink],
  templateUrl: './predisclaimer.component.html',
  styleUrl: './predisclaimer.component.scss',
  standalone: true,
})
export class PredisclaimerComponent {
  public selectedResident: string = '';
  public isAgreeChecked: boolean = false;
  private indexInfoService = inject(IndexIoService);

  public termsOfUsePath: string;
  public privacyPolicyPath: string;
  public privacyPolicyText: string;
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();

  constructor(private router: Router) {
    this.termsOfUsePath = '/TermsOfUse';
    this.privacyPolicyPath = 'https://cib.bnpparibas/data-protection-notice/';
    this.privacyPolicyText = 'Data Protection Notice';
    localStorage.setItem('selectedResident', this.selectedResident);
    this.USnonUsSelection();
  }

  public USnonUsSelection(): void {
    const isUS = this.selectedResident === 'US';
    //TO DO
    // const termsOfUsePath = isUS ? '/TermsOfUseUS' : '/TermsOfUse';
    this.termsOfUsePath = '/termofuse';
    this.privacyPolicyPath = isUS
      ? '/PrivacyPolicy'
      : 'https://cib.bnpparibas/data-protection-notice/';
    this.privacyPolicyText =
      this.privacyPolicyPath ===
      'https://cib.bnpparibas/data-protection-notice/'
        ? 'Data Protection Notice'
        : 'Privacy Policy';
  }

  public validatePreDisclaimer(): void {
    if (this.isAgreeChecked && this.selectedResident) {
      localStorage.setItem('predisclaimerAccepted', 'true');
      localStorage.setItem('selectedResident', this.selectedResident);
      if (this.selectedResident === 'US') {
        this.router.navigate(['/usdisclaimer']);
      } else {
        this.router.navigate(['/home']);
      }
    } else {
      alert('Please agree to terms and conditions.');
    }
  }

  public isFormValid(): boolean {
    return this.isAgreeChecked && !!this.selectedResident;
  }
}
